// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "-" + {"12":"90fa3024","175":"1922e547","233":"0547403e","369":"84669110","777":"d85915b3","936":"e2f4184c"}[chunkId] + ".js";
};